import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const displayedArticles = allArticles.slice(0, 10);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            Latest Guides &amp; Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            Explore our in-depth articles to get the most out of the VigorBuy Spreadsheet — from buying guides and QC tutorials to safety tips and platform comparisons.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {displayedArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}/`}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all group cursor-pointer overflow-hidden"
            >
              <div className="w-full aspect-[16/9] overflow-hidden bg-background-100">
                <div
                  className="w-full h-full bg-cover bg-center group-hover:scale-105 transition-transform duration-300"
                  style={{ backgroundImage: `url('${article.imageUrl}')` }}
                />
              </div>
              <div className="flex flex-col gap-2 p-4 md:p-5 flex-1">
                <span className="inline-flex self-start px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                  {article.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    Read More
                    <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <Link
            to="/vigorbuy-spreadsheet-guide/"
            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium whitespace-nowrap rounded-md border border-background-300/60 text-foreground-700 hover:bg-background-200 hover:text-foreground-900 transition-colors cursor-pointer"
          >
            View All Articles
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}